/**
 * List of constants required for ensighten tagging, we will be using on page level components to update jcpDl object
 */

const constants = {
    EVENTNAME: 'forgotPassword',
    PAGETYPE: 'account',
};

export default constants;
